export default __webpack_public_path__ + "static/media/coin.a2cdb8dd.svg";